export const GET_AFFILIATES_REQUEST = 'GET_AFFILIATES_REQUEST';
export const GET_AFFILIATES_SUCCESS = 'GET_AFFILIATES_SUCCESS';
export const GET_AFFILIATES_FAILURE = 'GET_AFFILIATES_FAILURE';

export const DOWNLOAD_REPORTS_REQUEST = 'DOWNLOAD_REPORTS_REQUEST';
export const DOWNLOAD_REPORTS_SUCCESS = 'DOWNLOAD_REPORTS_SUCCESS';
export const DOWNLOAD_REPORTS_FAILURE = 'DOWNLOAD_REPORTS_FAILURE';


